import styled, {
  DefaultTheme,
} from 'styled-components';

interface ButtonInterface {
  genre: 'primary' | 'secondary';
  block?: boolean;
  isLoading?: boolean;
}

function getGenre(theme: DefaultTheme, genre: string) {
  switch (genre) {
    case 'primary':
      return {
        color: '#ffffff',
        hoverColor: '#ffffff',
        borderColor: 'transparent',
        backgroundColor: theme.colors.primary,
        backgroundHoverColor: '#fb2370',
        backgroundDisabledColor: theme.colors.soft,
      };
    case 'secondary':
      return {
        color: theme.colors.clickable,
        hoverColor: theme.colors.header,
        backgroundColor: 'transparent',
        borderColor: theme.colors.clickable,
        backgroundHoverColor: 'transparent',
        backgroundDisabledColor: 'transparent',
      };
    default:
      return {
        color: '#ffffff',
        hoverColor: '#ffffff',
        borderColor: 'transparent',
        backgroundColor: theme.colors.primary,
        backgroundHoverColor: theme.colors.primary,
        backgroundDisabledColor: theme.colors.light,
      };
  }
}

const Button = styled.button<ButtonInterface>`
  font-family: ${(props) => props.theme.font.family};
  font-size: 14px;
  line-height: 41px;
  letter-spacing: 0.38px;
  text-align: center;
  font-weight: bold;

  line-height: 2.28;
  letter-spacing: 0.38px;
  font-style: normal;
  font-stretch: normal;
  color: ${(props) => getGenre(props.theme, props.genre).color};
  background-color: ${(props) => getGenre(props.theme, props.genre).backgroundColor};

  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);

  box-sizing: border-box;

  width: ${(props) => props.block && '100%'};

  padding: 8px 52px;

  border-radius: 25px;
  border-width: ${(props) => props.theme.border.width};
  border-color: ${(props) => getGenre(props.theme, props.genre).borderColor};
  border-style: solid;

  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:hover {
    color: ${(props) => getGenre(props.theme, props.genre).hoverColor};
    background-color: ${(props) => getGenre(props.theme, props.genre).backgroundColor};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${(props) => getGenre(props.theme, props.genre).backgroundDisabledColor};
  }
`;

export default Button;
